module.exports = __webpack_public_path__ + "static/media/CTLI_10-293w.0b49f690.jpg";